module.exports = __webpack_public_path__ + "static/keepitorganized-3bc4ad9a69203ab6ecba049f3f8b1104.png";